import get from 'lodash/get';
import * as companyIndexSectionPageActions from '../../action_creators/mic/company_index_section_page_action_creators';
import log from '../../../services/logger_service';
import asyncCompanyIndexSectionActions from './async_company_index_section_actions';
import asyncCompanyIndexSectionNextActions from './async_company_index_section_next_actions';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

export default function fetchCompanyPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(
      companyIndexSectionPageActions.companyIndexSectionPageLoading({}, store)
    );
    return Promise.all([
      asyncCompanyIndexSectionActions(params, store)(dispatch),
      asyncCompanyIndexSectionNextActions(params, store)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ])
      .then(function handlePostDetailData() {
        dispatch(
          companyIndexSectionPageActions.companyIndexSectionPageLoaded(
            {},
            store
          )
        );
        return true;
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in tag page actions, message: ${err.message}`);
        }
        dispatch(
          companyIndexSectionPageActions.companyIndexSectionPageLoadError(
            err,
            store
          )
        );
      });
  };
}
